import { render } from "./HelixButtons.vue?vue&type=template&id=0f80658e"
import script from "./HelixButtons.vue?vue&type=script&lang=js"
export * from "./HelixButtons.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__